/* eslint-disable react/prop-types */
import './index.scss';
import '../../views/PaymentProcessor/PaymentProcessor.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';

function ModalViewProcessorBanks({ modalIsOpen, setIsOpen, data }: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  const banks = data?.beneficiaryBanks || [];

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className={`modal-processor`}>
        <div className="modal-processor__header">
          <button onClick={closeModal}>&times;</button>
        </div>
        <h2>{data?.provider} Banks</h2>

        <div className="modal-processor__body">
          {banks.length > 0 ? (
            <ul className="modal-processor__banks-list">
              {banks.map((bank: any, index: number) => (
                <li key={index} className="modal-processor__bank-item">
                  {bank}
                </li>
              ))}
            </ul>
          ) : (
            <p className="modal-processor__no-banks">No banks assigned</p>
          )}
        </div>
      </div>
    </ModalBase>
  );
}

export default ModalViewProcessorBanks;
